// extracted by mini-css-extract-plugin
export default {"root":"GroupHeaderToolbar_root__ARIWA","placeHolderShimmer":"GroupHeaderToolbar_placeHolderShimmer__86dj2"};